import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["accountManager", "children", "contractManager", "error", "isLoading", "isSaving", "isStarterPortal"];
import PropTypes from 'prop-types';
import { Children } from 'react';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { PanelBody } from 'foundations-components/transitional/components/PanelBody';
import AccountManager from '../../records/AccountManager';
import ContractManager from '../../records/ContractManager';
import EscalateToSelect from '../fields/EscalateToSelect';
import Escalation from '../../records/Escalation';
import { View } from 'foundations-components/transitional/components/View';
import { PanelSection } from 'foundations-components/transitional/components/Panel';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const STARTER_PLAYBOOK_URL = 'https://wiki.hubspotcentral.net/pages/viewpage.action?pageId=503887568';
const childrenPropDefault = /*#__PURE__*/_jsx("div", {});
function EscalationPanelBody(_ref) {
  let {
      accountManager = undefined,
      children = childrenPropDefault,
      contractManager = undefined,
      error = null,
      isLoading = false,
      isSaving = false,
      isStarterPortal = false
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const props = Object.assign({
    accountManager,
    children,
    contractManager,
    error,
    isLoading,
    isSaving,
    isStarterPortal
  }, rest);
  const renderStarterPortalNote = () => {
    if (props.isStarterPortal) {
      return /*#__PURE__*/_jsx(FormattedJSXMessage, {
        "data-test-id": "escalation-panel-body-starter-note",
        message: "app.escalations.panel.body.starterNote_jsx",
        elements: {
          UILink: Link
        },
        options: {
          href: STARTER_PLAYBOOK_URL,
          target: '_blank'
        }
      });
    }
    return null;
  };
  return /*#__PURE__*/_jsxs(PanelBody, {
    children: [props.error ? props.error : null, props.isLoading ? /*#__PURE__*/_jsx(LoadingSpinner, {
      "data-test-id": "escalation-panel-body-loading-overlay",
      grow: true,
      layout: "centered"
    }) : /*#__PURE__*/_jsxs(PanelSection, {
      paddingInline: "600",
      paddingBlock: "300",
      children: [/*#__PURE__*/_jsx(View, {
        marginBlockEnd: "400",
        as: "div",
        children: /*#__PURE__*/_jsx(EscalateToSelect, {
          accountManager: props.accountManager,
          contractManager: props.contractManager,
          "data-test-id": "escalation-panel-body-escalate-to-select",
          isSaving: props.isSaving,
          isStarterPortal: props.isStarterPortal,
          onSelect: escalationType => props.onUpdate(props.escalation.set('type', escalationType)),
          selectedOption: props.escalation.type
        })
      }), Children.only(props.children), renderStarterPortalNote()]
    })]
  });
}
EscalationPanelBody.propTypes = {
  accountManager: PropTypes.instanceOf(AccountManager),
  children: PropTypes.node,
  contractManager: PropTypes.instanceOf(ContractManager),
  error: PropTypes.node,
  escalation: PropTypes.instanceOf(Escalation).isRequired,
  isLoading: PropTypes.bool,
  isSaving: PropTypes.bool,
  isStarterPortal: PropTypes.bool,
  onUpdate: PropTypes.func.isRequired
};
export default EscalationPanelBody;